// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3nxFr","title":"style_title__3d9mg","subtitle":"style_subtitle__TIjYl"};